__turbopack_context__.v({
  "innerNoOuterScroll": "_9wC3NG_innerNoOuterScroll",
  "root": "_9wC3NG_root",
  "sidebar-container": "_9wC3NG_sidebar-container",
  "sidebar-container-inner": "_9wC3NG_sidebar-container-inner",
  "sidebar-container-inner-wrapper": "_9wC3NG_sidebar-container-inner-wrapper",
  "sidebar-main": "_9wC3NG_sidebar-main",
  "sidebar-overlay": "_9wC3NG_sidebar-overlay",
});
